export default __webpack_public_path__ + "static/media/872.86321dde.png";